<template>
    <div class="app-container">
        <div class="filter-container">
            <el-input v-model="listQuery.phone" placeholder="手机号" style="width: 200px" class="filter-item" clearable />
            <el-select v-model="listQuery.agentName" placeholder="代理商名称" style="width: 120px" class="filter-item"
                clearable>
                <el-option v-for="item in agentConfigList" :key="item.id" :label="item.agentName" :value="item.agentName" />
            </el-select>

            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
        </div>

        <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" size="small" border fit
            highlight-current-row>
            <el-table-column label="序号" align="center" type="index" min-width="50"></el-table-column>
            <el-table-column label="代理商名称" align="center" prop="agentName" min-width="120"></el-table-column>
            <el-table-column label="手机号" align="center" prop="phone" min-width="120"></el-table-column>
            <el-table-column label="下级数量" align="center" prop="subordinateCount" min-width="100">
                <template slot-scope="scope">
                    {{ `${scope.row.subordinateCount}个` }}
                </template>
            </el-table-column>
            <el-table-column label="上级手机号" align="center" prop="superiorPhone" min-width="120"></el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-size="listQuery.pageSize" :total="total" background
                layout=" prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
    </div>
</template>

<script>
import {
    getAgentList, getAgentConfig
} from "@/api/agent-management.js";

export default {
    name: "agentManagementList",
    data() {
        return {
            list: [],
            total: null,
            listLoading: true,
            listQuery: {
                page: 1,
                pageSize: 10,
                phone: "",
                agentUserId: "",
                agentName:""
            },
            agentConfigList: [],
        };
    },
    created() {
        this.onAgentConfig();
        this.getList();
    },

    methods: {
        /**
         * 获取代理商配置列表
         */
        onAgentConfig() {
            getAgentConfig().then((res) => {
                this.agentConfigList = res.data;
            });
        },

        getList() {
            this.listLoading = false;

            getAgentList(this.listQuery).then((res) => {
                this.list = res.data.entitys;
                this.total = res.data.totalCount;
                console.log("分润list-1", res, this.list);
                this.listLoading = false;
            });
        },
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
    width: 40px;
    height: 40px;
}
</style>
